"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
function RecipesFilter({ namespace, filter, taxonomy }) {
    const labelId = `${namespace}-filter-${taxonomy.slug}`;
    return ((0, preact_1.h)("div", { className: 'filters__block' },
        (0, preact_1.h)("label", { htmlFor: labelId, className: 'visually-hidden' }, taxonomy.title),
        (0, preact_1.h)("select", { id: labelId, name: taxonomy.slug, onChange: filter.handleInput, className: 'filters__input' },
            (0, preact_1.h)("option", { value: '', "aria-label": 'All' }, taxonomy.title),
            taxonomy.terms.map((term) => ((0, preact_1.h)("option", { key: term.slug, value: term.slug, selected: filter.isSelected(taxonomy.slug, term.slug) }, term.title))))));
}
exports.default = RecipesFilter;
